import React from 'lib/react';
import {
  EVGrid, EVPaper, EVTypography, makeStyles, EVSkeleton,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';
import clsx from 'lib/clsx';

const useStyles = makeStyles((theme) => ({
  reportsList: {
    backgroundColor: theme.evPalette.charcoal[100],
    padding: '8px',
    rowGap: '8px',
  },
  reportListItem: {
    position: 'relative',
    padding: '16px',
    rowGap: '8px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    '&>div': {
      '&:first-child': { fontWeight: 600 },
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: theme.evPalette.charcoal[900],
    },
    '&.border': {
      border: `1px solid ${theme.evPalette.ocean[600]}`,
      borderRight: 'none',
    },
  },
  reportDetailRow: {
    columnGap: '16px',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    '&>div>p': {
      color: theme.evPalette.charcoal[800],
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '24px',
      '&:first-child': {
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '18px',
        color: theme.evPalette.charcoal[900],
      },
    },
  },
  actions: {
    gap: '8px',
    '&>*': {
      width: 'unset',
      flex: '1 0 40%',
      justifyContent: 'center',
    },
  },
  detailsBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
    boxSizing: 'border-box',
    height: '100%',
    minWidth: '44px',
    width: '44px',
    borderRight: '5px solid',
    padding: 0,
  },
  reportDetailListItem: {
    width: '80px',
  },
}));

function ExportDataList({ reportAnalyticsList, loading }) {
  const classes = useStyles();
  const displayHeader = (title) => (loading ? <EVSkeleton style={{ borderRadius: '6px' }} width={63} height={18} animation="wave" /> : title);
  const { t } = useTranslation();
  return (
    <EVGrid className={classes.reportsList} container direction="column">
      {(reportAnalyticsList?.length > 0) ? reportAnalyticsList.map(({
        rowKey,
        address, reportType, structureType,
        reportId, deliveredDate, orderPlacedDate, cost,
      }) => (
        <EVPaper key={rowKey} className={clsx(classes.reportListItem)}>
          <EVGrid container justifyContent="space-between" alignItems="center">
            {address}
          </EVGrid>
          <EVGrid>
            {reportType}
          </EVGrid>
          <EVGrid>
            {structureType}
          </EVGrid>
          <EVGrid container className={classes.reportDetailRow}>
            <EVGrid className={classes.reportDetailListItem}>
              <EVTypography>{displayHeader(t('order_history__report_id'))}</EVTypography>
              <EVTypography>{reportId}</EVTypography>
            </EVGrid>
            <EVGrid className={classes.reportDetailListItem}>
              <EVTypography>{displayHeader(t('common_ordered'))}</EVTypography>
              <EVTypography>{orderPlacedDate}</EVTypography>
            </EVGrid>
            <EVGrid className={classes.reportDetailListItem}>
              <EVTypography>{displayHeader(t('common_delivered'))}</EVTypography>
              <EVTypography>{deliveredDate}</EVTypography>
            </EVGrid>
            <EVGrid className={classes.reportDetailListItem}>
              <EVTypography>{displayHeader(t('common__cost'))}</EVTypography>
              <EVTypography>{cost}</EVTypography>
            </EVGrid>
          </EVGrid>
        </EVPaper>
      )) : <EVGrid>No results</EVGrid>}
    </EVGrid>
  );
}

ExportDataList.propTypes = {
  reportAnalyticsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ExportDataList;
